module.exports = function formatDate(value) {
    if (value == null || value.length === 0) return null;

    const d = new Date(value);
    if (isNaN(d.getTime())) return null;

    const weekdayArr = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    const monthArr = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    const weekday = weekdayArr[d.getDay()];
    const month = monthArr[d.getMonth()];
    const date = d.getDate();

    return `${weekday}, ${date} ${month}`;
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/utility/date-formatter.js
 **/